import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CommandContribution } from '@patsnap/tahiti-core';
import { FtoApi, FtoApiImpl } from './apis';
import { FtoExampleService, FtoExampleServiceImpl } from './services/fto-example-service';
import { FtoCommandContribution } from './services/fto-command-contribution';

export const ftoContainer = new ContainerModule((bind) => {
    bind(FtoApi).to(FtoApiImpl);
    bind(FtoExampleService).to(FtoExampleServiceImpl);
    bind(CommandContribution).to(FtoCommandContribution);
});

export { default as FtoContainer } from './components/containers/FtoContainer.vue';
